import styled from "styled-components";

export const SuggestedVideoSlidesFilterListPreviewContentDefaultBox = styled.div`
    display: flex;
    gap: 10px; 
    height: 200px;
`;